import uniqWith from 'lodash-es/uniqWith';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import compareFindRecipientPersonaType from 'owa-recipient-common/lib/utils/compareFindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';

export default action('insertRecipientsShownAtFront')(function insertRecipientsShownAtFront(
    resultsToPopulate: FindRecipientPersonaType[],
    recipientsToInsert: ReadWriteRecipientViewState[],
    maxEntries: number
) {
    const personaTypes = recipientsToInsert.map(recipient => recipient.persona);
    // The slice is important here, it forces an ObservableArray to become a regular array.
    const mergedArrays = personaTypes.concat(resultsToPopulate.slice());
    const newResult = uniqWith(mergedArrays, compareFindRecipientPersonaType);
    resultsToPopulate.splice(0, 0, ...newResult);
    resultsToPopulate.length = Math.min(resultsToPopulate.length, maxEntries);
});
